import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  InspectionTemplateServiceTaskOptionsState,
  inspectionTemplateServiceTaskOptionsFeatureKey,
} from '../reducers/inspection-template-service-task-options.reducer';

export const selectInspectionTemplateServiceTaskOptionsState =
  createFeatureSelector<InspectionTemplateServiceTaskOptionsState>(inspectionTemplateServiceTaskOptionsFeatureKey);

export const selectTemplateServiceTaskOptions = createSelector(
  selectInspectionTemplateServiceTaskOptionsState,
  (state: InspectionTemplateServiceTaskOptionsState) => state.options
);

export const selectTemplateServiceTaskOptionsLoading = createSelector(
  selectInspectionTemplateServiceTaskOptionsState,
  (state: InspectionTemplateServiceTaskOptionsState) => state.loading
);

export const selectTemplateServiceTaskOptionsError = createSelector(
  selectInspectionTemplateServiceTaskOptionsState,
  (state: InspectionTemplateServiceTaskOptionsState) => state.error
);
